import { invoke } from '@tauri-apps/api/core';

export interface LocalClipboardFile {
  name: string;
  size: number;
  path: string;
}

export interface LocalClipboard {
  text: string | null;
  /** Há uma imagem; os bytes vêm de `localClipboardImage`. */
  image: boolean;
  files: LocalClipboardFile[];
  skippedFolders: number;
  /** Muda a cada gravação na área de transferência. */
  sequence: number;
}

export function localClipboardRead(): Promise<LocalClipboard> {
  return invoke<LocalClipboard>('local_clipboard_read');
}

/** A imagem da área de transferência local, em PNG. */
export async function localClipboardImage(): Promise<Uint8Array> {
  return new Uint8Array(await invoke<ArrayBuffer>('local_clipboard_image'));
}

export function localClipboardWriteText(text: string): Promise<void> {
  return invoke('local_clipboard_write_text', { text });
}

/** Grava o PNG como imagem e devolve a sequência da área de transferência depois disso. */
export function localClipboardWriteImage(png: Uint8Array): Promise<number> {
  return invoke<number>('local_clipboard_write_image', png);
}

export function localClipboardWriteFiles(paths: string[]): Promise<void> {
  return invoke('local_clipboard_write_files', { paths });
}

export async function readFileChunk(path: string, offset: number, length: number): Promise<Uint8Array> {
  const raw = await invoke<ArrayBuffer>('read_file_chunk', { path, offset, length });
  return new Uint8Array(raw);
}

export interface DownloadStarted {
  id: string;
  path: string;
}

export function downloadBegin(name: string): Promise<DownloadStarted> {
  return invoke<DownloadStarted>('download_begin', { name });
}

export function downloadWrite(id: string, offset: number, bytes: Uint8Array): Promise<void> {
  return invoke('download_write', bytes, { headers: { 'x-id': id, 'x-offset': String(offset) } });
}

export function downloadAbort(id: string): Promise<void> {
  return invoke('download_abort', { id });
}

export function clipboardOffer(clipboardId: string, files: { name: string; size: number }[]): Promise<void> {
  return invoke('clipboard_offer', { clipboardId, files });
}

export function clipboardRelease(): Promise<void> {
  return invoke('clipboard_release');
}

export function clipboardPullWrite(transferId: string, offset: number, bytes: Uint8Array): Promise<void> {
  return invoke('clipboard_pull_write', bytes, { headers: { 'x-id': transferId, 'x-offset': String(offset) } });
}

export function clipboardPullEnd(transferId: string): Promise<void> {
  return invoke('clipboard_pull_end', { transferId });
}

export function clipboardPullFail(transferId: string): Promise<void> {
  return invoke('clipboard_pull_fail', { transferId });
}
